export default __webpack_public_path__ + "static/media/calendar-icon.a7a93688.svg";